function getEntries(query) {
  var entries = Array.from(document.querySelectorAll(query));
  var firstElement = entries[0];
  var lastElement = entries[entries.length - 1];
  return {
    entries: entries,
    firstElement: firstElement,
    lastElement: lastElement
  };
}
/**
 * Helper method to find the next focusable sibling element relative to the
 * specified element.
 *
 * @param {string} query  - Argument that gets passed to document.querySelectorAll
 * @param {HTMLElement} element - Specified element (e.target)
 * @returns {HTMLElement} - element to be focused
 */


export function getNextSibling(query, element) {
  var _getEntries = getEntries(query),
      entries = _getEntries.entries,
      firstElement = _getEntries.firstElement,
      lastElement = _getEntries.lastElement;

  if (element === lastElement) {
    return firstElement;
  }

  var elementIndex = entries.indexOf(element);
  return entries[elementIndex + 1];
}
/**
 * Helper method to find the previous focusable sibling element relative to the
 * specified element.
 *
 * @param {string} query  - Argument that gets passed to document.querySelectorAll
 * @param {HTMLElement} element - Specified element (e.target)
 * @returns {HTMLElement} - element to be focused
 */

export function getPreviousSibling(query, element) {
  var _getEntries2 = getEntries(query),
      entries = _getEntries2.entries,
      firstElement = _getEntries2.firstElement,
      lastElement = _getEntries2.lastElement;

  if (element === firstElement) {
    return lastElement;
  }

  var elementIndex = entries.indexOf(element);
  return entries[elementIndex - 1];
}
//# sourceMappingURL=dom-query.js.map